
import React from 'react';
import { connect } from 'react-redux';

import Item from './Item';

let Itams = ({invoices, setInvoices}) => {
  if (invoices){
    const invoicesI = invoices.invoices
    const invoiceItems = Object.keys(invoicesI).map((key, index) => {
      return (
        <Item invoice={invoicesI[key]} key={invoicesI[key].id} />
      );
    }
    )
  return  invoiceItems;
  }
  return (
    <div>
    </div>
  );
};
const viewMapStateToProps = (state) => {
  return {
    invoices: state.Invoices,
  }
}

const viewMapDispatchToProps = (dispatch) => {
  return {
    setInvoices: (invoices) => {
      dispatch(
        {
          type: 'SET_INVOICES',
          invoices: invoices,
        },
      );
    },
  }
}

Itams = connect(
  viewMapStateToProps,
  viewMapDispatchToProps,
)(Itams);

export default Itams;



// WEBPACK FOOTER //
// ./src/lib/tables/Items.js